/*
 * @Author: alex.dai
 * @Date: 2023-04-10 15:33:22
 * @LastEditors: alex.dai
 * @LastEditTime: 2023-04-20 15:42:22
 * @FilePath: /new-frontend/src/api/modules/order.js
 * @Description:
 */
// 订单管理
import $ from '../base'

export default {

  // 充值订单 - 列表
  rechargeList: $.post('order/queryOrderList'),
  orderItemList: $.post('order/items/pages'),
  orderItemRecordList: $.post('order/items/sendRecord'),

  // 批量充值订单 - 导出
  exportList: $.BASE_URL + 'order/outFailOrder',

  // 充值订单 - 导出
  outQueryOrder: $.BASE_URL + 'order/outQueryOrder',

  // 卡密订单 - 列表
  carmiList: $.post('cardOrder/queryCardOrderList'),

  // 卡密订单 - 导出
  carmiOutQueryOrder: $.BASE_URL + 'cardOrder/outQueryCardOrder',

  // 卡密订单 - 手动购买
  carmiManualBuy: $.post('cardOrder/cardManualRecharge'),

  // 卡密订单 - 批量导入
  carmiBatchImport: $.BASE_URL + 'cardOrder/batchInsertCard',

  // 流水状态变更
  flowChange: $.post('order/flowChange'),

  // 平台手动权益下单
  uniManualOrder: $.post('/plat/uniManualOrder'),

  rollbackOrder: $.post('/order/putRollData'),

  queryCommodityItems: $.post('/commodity/queryCommodityItems'),

  writeOffInfo: $.post('/order/items/writeOffInfo'),

  productOrderPage: $.post('/productOrder/pages'),

  productOrderDetails: $.post('/productOrder/details'),
  productOrderDetailsOutExport: $.BASE_URL + '/productOrder/outExport',

  dashboardChart: $.post('/dashboard/chart'),
  // 订单 - 导出
  productOrderOut: $.BASE_URL + '/productOrder/export',
}
